export default {
  Title: 'Đối chiếu dữ liệu chuyển đổi',
  EmptyConvert: 'Sau khi kiểm tra, phần mềm không phát hiện sai lệch',
  ViewOnlyDifference: 'Chỉ hiển thị tài khoản có chênh lệch',
  Account: 'Tài khoản',
  ContentCheck: 'Các nội dung cần kiểm tra',
  TooltipDifference: 'Kết quả đối chiếu có sự khác biệt',
  CompletedCompare: 'Đã hoàn thành đối chiếu',
  CompleteButton: 'Hoàn thành đối chiếu',
  ContentTitleError: 'Hiện tại đang có <b>{0} nội dung</b> chênh lệch',
  TitleResultDifferenceArisePopup: 'Phát sinh chênh lệch',
  NoDifferenceArise: 'Sau khi kiểm tra, phần mềm không phát hiện sai lệch',
  ContentAriseError: 'Hiện tại có <b>{0}</b> nội dung cần kiểm tra:',
};
